import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { routeCodes } from "../../config/routes";
import { premiumRequired } from "../../utilities";
import FlareShimmer from "../global/FlareShimmer";
import Shimmer from "../../../assets/img/shimmer2.png";

export default function CategoryNav({ categories }) {
  const navigate = useNavigate();

  // users not logged in or logged in and free

  if (categories && categories.length > 0) {
    return categories.map((cat) => {
      // if premiumRequired is true and category is considered premium
      return (
        <button
          type="button"
          key={cat.shortname}
          className={`button-flat-color round dimensional ${cat.shortname}`}
          onClick={() => {
            navigate(`${routeCodes.CATEGORYPRINTABLES}${cat.shortname}`);
          }}
        >
          {cat.name}
          <div className="pnc-button-premium-container">
            {premiumRequired([cat.shortname]) && (
              <div className="pnc-button-premium">
                <FlareShimmer filePath={Shimmer} />
              </div>
            )}
          </div>
        </button>
      );
    });
  }

  return null;
}

CategoryNav.propTypes = {
  categories: PropTypes.array,
};

CategoryNav.defaultProps = {
  categories: undefined,
};
